export default function style(theme) {
  return {
    footerBackground: {
      background: theme.palette.primary.main,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    footerBackground__main: {
      maxWidth: 1200,
      padding: "0rem 1rem",
      margin: "2rem",
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        margin: "2rem 0rem",
      },
    },
    secondaryTitle: {
      fontSize: "3rem",
      fontFamily: "Poppins",
      margin: "1rem 0rem",
      textAlign: "left",
      width: "100%",
      fontWeight: 600,
      color: theme.palette.text.primary,
      [theme.breakpoints.down("sm")]: {
        fontSize:  "2rem",
      },
    },
    footerColumn: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gridGap: "1rem",
      [theme.breakpoints.down("sm")]: {
        display: "block"
      },
    },
    contactLinksContainer:{
      marginBottom: "2rem",
      display: "flex",
      flexDirection: "column",
      alignItems: "end",
      justifyContent:"end",
      [theme.breakpoints.down("sm")]: {
        marginTop: "2rem",
        alignItems: "flex-start",
      },
    },
    contactLinks:{
      display: "flex", 
      alignItems: "flex-start", 
      gap: "1rem" , 
      justifyContent:"end",
      width: "fit-content",
      [theme.breakpoints.down("sm")]: {
        justifyContent:"start",
        width: "fit-content",
        flexDirection: "row-reverse",
      },
    },
    footer_desc: {
      marginBottom: "1rem",
      fontWeight: "100",
      textAlign: "left",
      color: theme.palette.text.tertiary,
    },
    footer_author: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
    },
    footer_end:{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      margin: "1.4rem 0 0",
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column-reverse"
      },
    },
  };
}
